import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const removeGlobalBlacklistTerm = unaryRpc({
  name: "removeGlobalBlacklistTerm",
  input: z.object({ id: z.string() }),
  output: z.object({}),
});
